<template>
    <div>
        <div class="row">
            <div class="col-md-6 d-flex justify-content-around">
                <div>
                <h3 style="color:#87a8a7;">MANO DERECHA</h3>
                    <div id="little_right" @click="openModalCaptureFingerPrint({id:'little_right', name: 'Meñique derecho'})" class="finger-right little-right"></div>
                    <div id="ring_right" @click="openModalCaptureFingerPrint({id:'ring_right', name: 'Anular derecho'})" class="finger-right ring-right"></div>
                    <div id="middle_right" @click="openModalCaptureFingerPrint({id:'middle_right', name: 'Medio derecho'})" class="finger-right middle"></div>
                    <div id="index_right" @click="openModalCaptureFingerPrint({id:'index_right', name: 'Índice derecho'})" class="finger-right index-right"></div>
                    <div id="thumb_right" @click="openModalCaptureFingerPrint({id:'thumb_right', name: 'Pulgar derecho'})" class="finger-right thumb-right"></div>
                    <div class="palm-right"></div>
                    <div class="wrist"></div>
                </div>
            </div>
            <div class="col-md-6 d-flex justify-content-around">
                <div>
                <h3 style="color:#87a8a7;">MANO IZQUIERDA</h3>
                    <div id="thumb_left" @click="openModalCaptureFingerPrint({id:'thumb_left', name: 'Pulgar izquierdo'})" class="finger thumb"></div>
                    <div id="index_left" @click="openModalCaptureFingerPrint({id:'index_left', name: 'Índice izquierdo'})" class="finger index"></div>
                    <div id="middle_left" @click="openModalCaptureFingerPrint({id:'middle_left', name: 'Medio izquierdo'})" class="finger middle"></div>
                    <div id="ring_left" @click="openModalCaptureFingerPrint({id:'ring_left', name: 'Anular izquierdo'})" class="finger ring"></div>
                    <div id="little_left" @click="openModalCaptureFingerPrint({id:'little_left', name: 'Meñique izquierdo'})" class="finger little"></div>
                    <div  class="palm"></div> 
                    <div class="wrist"></div>
                </div>
            </div>
                    
        </div>
        <modalCaptureFingerPrint ref="modal" @send-fingerprintvalue="loadFingerPrint"></modalCaptureFingerPrint>
    </div>
</template>
<script>
import { defineComponent, ref, reactive, onMounted, computed } from "vue";
import modalCaptureFingerPrint from "@/views/filiation/modalCaptureFingerPrint.vue";
export default defineComponent({
  name: "handsComponent",
  emits: ['send-fingerprintvalue'],
  components: {
    modalCaptureFingerPrint
  },
  setup(props, ctx){
      const dialog = ref(false);
      const modal = ref(null);
      const openModalCaptureFingerPrint = ({id,name}) => {
        dialog.value=true;
        modal.value.showModal({dialog: dialog.value, id:id, name: name});
    };
      const loadFingerPrint = async(value) =>{
        var div = document.getElementById(value.id_finger);
        div.style.backgroundColor = "green"
        ctx.emit("send-fingerprintvalue", value)
      }
        return{
          dialog,
          modal,
          openModalCaptureFingerPrint,
          loadFingerPrint,
          
        }
    },
})
</script>

<style scoped>


/* .........div holding entire hand........... */

.a-hand{
  background: orange;
  width: 80%;
  padding: 8% 20%;
  margin: 0 auto;
  position: relative;
}
/* ........................................ */


/* .....common style for finger, palm and wrist.... */

.finger, .finger-right, .palm, .palm-right, .wrist{
  background: #eee;
}
/* .................................. */


/* ...common style for all fingers... */

.finger{
  display: inline-block;
  height: 130px;
  width: 26px;
  z-index: 3;
  border-radius: 25%;
  position: relative;
  left: -20px;
  bottom: -45px;
  box-shadow: 3px 0 10px #333;
  margin-right: 2px;
}
.finger-right{
  display: inline-block;
  height: 130px;
  width: 26px;
  z-index: 3;
  border-radius: 25%;
  position: relative;
  right: -20px;
  bottom: -45px;
  box-shadow: 3px 0 10px #333;
  margin-left: 2px;
}
/* ................................. */

/**************************************/
/* ...........style for each fingers........ */

/* ............Thumb....... */
.thumb{
  width: 30px;
  height: 60px;
  margin-right: 20px;
  -ms-transform: rotate(-38deg);
  -webkit-transform: rotate(-38deg);
  -o-transform: rotate(-38deg);
  transform: rotate(-38deg);
}
.thumb-right{
  width: 30px;
  height: 60px;
  margin-left: 25px;
  -ms-transform: rotate(38deg);
  -webkit-transform: rotate(38deg);
  -o-transform: rotate(38deg);
  transform: rotate(38deg);
}

/* ...................... */

/* ...............index......... */
.index{
  -ms-transform: rotate(-5deg);
  -webkit-transform: rotate(-5deg);
  -o-transform: rotate(-5deg);
  transform: rotate(-5deg);
  margin-right: 3px;
}
.index-right{
  -ms-transform: rotate(5deg);
  -webkit-transform: rotate(5deg);
  -o-transform: rotate(5deg);
  transform: rotate(5deg);
  margin-left: 3px;
}

/* ..............................*/

/* ...............middle............. */
.middle{
 height: 140px; 
}
/* ................................. */

/* ...............ring.............. */
.ring{
  margin-right: 3px;
  -ms-transform: rotate(4deg);
  -webkit-transform: rotate(4deg);
  -o-transform: rotate(4deg);
  transform: rotate(4deg);
}
.ring-right{
    margin-left: 3px;
  -ms-transform: rotate(-4deg);
  -webkit-transform: rotate(-4deg);
  -o-transform: rotate(-4deg);
  transform: rotate(-4deg);
}

/* ................................ */

/* ...............little............. */
.little{
  width: 24px;
  height: 100px;
  -ms-transform: rotate(9deg);
  -webkit-transform: rotate(9deg);
  -o-transform: rotate(9deg);
  transform: rotate(9deg);
}
.little-right{
  width: 24px;
  height: 100px;
  margin-left: -10px;
  -ms-transform: rotate(-9deg);
  -webkit-transform: rotate(-9deg);
  -o-transform: rotate(-9deg);
  transform: rotate(-9deg);
}

/* .................................. */

/* ************************************** */
/* .........................................*/


/* ...............style for palm............. */

.palm{
  position: relative;
  height: 120px;
  width: 150px;
  z-index: 3;
  box-shadow: 3px 0 3px #333;
  border-radius: 20% 20% 45% 45%;
}
.palm-right{
  position: relative;
  height: 120px;
  width: 150px;
  z-index: 3;
  box-shadow: -3px 0 3px #333;
  border-radius: 20% 20% 45% 45%;
}
/* ......................................... */


/* ..........style for wrist............ */

.wrist{
  height: 100px;
  width: 50px; 
  box-shadow: 2px 8px 20px 4px #333;
  border-radius: 10%;
  position: relative;
  left: 50px;
  top: -40px;
}

</style>